module.exports = __webpack_public_path__ + "media/images/redrock/signup-header-desktop2-97c1c107fedfcf0bba6dbfd632de5a2c.jpeg";